import React, { useEffect, useState, useContext } from "react";
import { loginUser, switchUserLogin  } from '../components/Api';
import { Link, useNavigate } from 'react-router-dom';
import Darkimg from '../assets/img/curve2.png';
import whiteimg from '../assets/img/curve1.png';
import Darkbg from '../assets/img/user-login-dark.webp';
import whitebg from '../assets/img/user-login-light.webp';
import Darkloginimg from '../assets/img/login/login-orange.gif';
import whiteloginimg from '../assets/img/login/login-green.gif';
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import * as colors from "../assets/css/Colors";
import Loader from '../components/Loader';
import Imagegif from "../components/Image_gif";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Header from '../layout/Header';
import Footer from '../layout/Footer';


const Login = () => {
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageInfo, setMessageInfo] = useState({ type: '', message: [] });
  const navigate = useNavigate();
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [userId, setUserId] = useState(null); // Define userId state
  const [ipAddress, setIpAddress] = useState(null); // Define ipAddress state

  const handleCloseModal = () => setShowModal(false);

  const [showNewPopup, setShowNewPopup] = useState(false);
  const [newPopupInfo, setNewPopupInfo] = useState({ type: '', message: [] });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    // Hide all popups initially
    setShowModal(false);
    setShowNewPopup(false);
  
    try {
      const loginData = { id, password };
      const response = await loginUser(loginData);
      const { status, message, token, user_id, username, registration_number, is_firstLogin } = response;
  
      if (status === 200) {
        // Store token, user details, and is_firstLogin in localStorage
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify({
          id: user_id,
          username: username,
          registration_number: registration_number, 
          is_firstLogin: is_firstLogin, // Storing is_firstLogin
        }));
  
        setUserId(user_id); 
        setMessageInfo({ type: 'success', message: [message] });
        setShowModal(true);
  
        // Redirect based on is_firstLogin
        setTimeout(() => {
          setShowModal(false);
          if (is_firstLogin === "0") {
            navigate('/Registration-Organization'); // Redirect to page-1 if not first login
          } else if (is_firstLogin === "1") {
            navigate('/Organization-Dashboard'); // Redirect to page-2 if first login
          }
        }, 5000);
      } else if (status === 500) {
        setMessageInfo({ type: 'error', message: ['Server error. Please try again later.'] });
        setShowModal(true);
      } else if (status === 405) {
        const errorMessage = response?.message || 'Method not allowed.';
        setNewPopupInfo({ type: 'info', message: [errorMessage] });
        setShowNewPopup(true);
        setUserId(user_id);
        localStorage.setItem('userId', user_id);
      } else {
        setMessageInfo({ type: 'error', message: ['Unexpected response status.'] });
        setShowModal(true);
      }
    } catch (error) {
      console.error('Error logging in:', error);
      const errorMessages = [];
  
      if (error.response) {
        const { data } = error.response;
        setUserId(data?.user_id);
        localStorage.setItem('userId', data?.user_id);
  
        if (data?.error?.id) {
          errorMessages.push('The ID provided is incorrect.');
        }
        if (data?.error?.password) {
          errorMessages.push('The password provided is incorrect.');
        }
        if (data?.error?.account) {
          errorMessages.push('The account is inactive or blocked.');
        }
      }
  
      if (error.response?.status === 405) {
        const errorMessage = error.response?.data?.message || 'Method not allowed.';
        setNewPopupInfo({ type: 'info', message: [errorMessage] });
        setShowNewPopup(true);
        setShowModal(false);
      } else {
        setMessageInfo({
          type: 'error',
          message: errorMessages.length > 0 ? errorMessages : ['Form Error, please check.']
        });
        setShowModal(true);
        setTimeout(() => setShowModal(false), 5000);
      }
    } finally {
      setLoading(false);
    }
  };
  
  

  const handleSwitchUserLogin = async () => {
    setLoading(true);
    try {
      // Retrieve userId from localStorage
      const storedUserId = localStorage.getItem('userId');

      // If userId is not found in localStorage, use the one from state
      const userIdToSend = storedUserId || userId;

      await switchUserLogin(userIdToSend, ipAddress);
      window.location.reload(); 
    } catch (error) {
      console.error("Error switching user login:", error);
    } finally {
      setLoading(false);
      setShowNewPopup(false);
    }
  };



  // end

  const lightImageURL = whiteimg;
  const darkImageURL = Darkimg;
  const lightBgURL = whitebg;
  const darkBgURL = Darkbg;
  const lightloginURL = whiteloginimg;
  const darkloginURL = Darkloginimg;

  const [colorScheme, setColorScheme] = useState(
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const handleChange = (e) => {
      setColorScheme(e.matches ? 'dark' : 'light');
    };

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  useEffect(() => {
    const element = document.querySelector(".ban-short-links");
    if (element) {
      element.classList.add("ani");
    }
  }, []);


  const styles = {
    background: colorScheme === 'dark'
      ? `linear-gradient(90deg, ${colors.theme_black_color}, ${colors.theme_white_color} 95%)`
      : `linear-gradient(90deg, ${colors.theme_white_color}, ${colors.theme_black_color} 95%)`,
  };

  const [focusedInput, setFocusedInput] = useState(null);

  const inputStyles = (isFocused) => ({
    borderColor: isFocused
      ? `${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`
      : '#000',
    boxShadow: isFocused
      ? 'none'
      : 'none',
    transition: 'border-color 0.3s',
  });

  const [activeLog, setActiveLog] = useState('log-1');

  const handleButtonClick = (logClass) => {
    setActiveLog(logClass);
  };

  const MessageModal = ({ show, handleClose, messageInfo }) => (
    <Modal
      show={show}
      onClick={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title className={`error_massage_header ${messageInfo.type}`}>
          {messageInfo.type === 'error' ? (
            <Imagegif text={'error'} />
          ) : (
            <Imagegif text={'successfully'} />
          )}
          {show && (
            <ul className={`error_massage_contet ${messageInfo.type}`}>
              {messageInfo.message.map((msg, index) => (
                <li key={index} className={`${messageInfo.type}_message`}>
                  {messageInfo.type === 'error' ? (
                    <span className="error_icon"></span>
                  ) : (
                    <div className="success_icon">
                      <h1>Thank You!</h1>
                    </div>
                  )}
                  {msg}
                </li>
              ))}
            </ul>
          )}
        </Modal.Title>
      </Modal.Header>
    </Modal>
  );

  const NewPopupModal = ({ show, handleClose, popupInfo }) => (
    <Modal
      show={show}
      onClick={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton className="already-logged-user-popup">
      <Modal.Title className={`error_massage_header ${messageInfo.type}`}>
          {messageInfo.type === 'error' ? (
            <Imagegif text={'error'} />
          ) : (
            <Imagegif text={'error'} />
          )}
          {show && (
            <div className={`error_massage_contet ${messageInfo.type}`}>
          {popupInfo.type === 'info' && (
            <ul className="error_message_content">
              {popupInfo.message.map((msg, index) => (
                <>
                <li key={index} className="error_message">
                {msg}
                  <span className="error_icon"></span>
                  {/* This account is already logged in on another device. */}
                </li>
                <li key={index} className="error_message">
                  <span className="error_icon"></span>
                  If you are the owner of this account, please click on the logout button and log in again. For security reasons, it is recommended to change your password to keep your data more secure.
                </li>
                <li key={index} className="error_message">
                  <Button variant="primary" onClick={handleSwitchUserLogin} disabled={loading}>
          {loading ? 'Switching...' : 'Logout'}
        </Button>
                </li>
                </>
              ))}
            </ul>
          )}
            </div>
          )}
        </Modal.Title>
      </Modal.Header>
    </Modal>
  );

    const [isChecked, setIsChecked] = useState(true);
  
    const handleCheck = () => {
      setIsChecked(!isChecked);
    };

    // Define dynamic styles based on checked/unchecked state
  const checkboxStyles = {
    background: isChecked ? `${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}` : '#fff',
    border: isChecked ? '2px solid' : '2px solid',
    borderColor: isChecked ? `${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}` : `${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius:'5px',
  };

  const checkmarkStyles = {
    color: 'white',
    fontSize: '16px',
    display: isChecked ? 'block' : 'none',
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  

  return (
    <>
      {loading && <Loader />}
      <Header />
      <div className="str ind2-home login-page">
        <div className="hom-head" style={{ backgroundImage: `url(${colorScheme === 'light' ? lightBgURL : darkBgURL})` }}>
          <Container>
            <Row>
              <div className="ban-tit">
                <h1>
                  <b>Are you an <span style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>Indian ?
                    <img src={colorScheme === 'light' ? lightImageURL : darkImageURL} alt="sharp" />
                  </span>
                  </b>
                  <br />
                  <span style={{ lineHeight: '32px' }}>
                  Do digital Indian Citizen Card make it easier to your identity and your Professional details
                  </span>
                </h1>
              </div>
            </Row>
          </Container>
        </div>
      </div>
      <section className="mt-0 mb-60">
      <Container>
        <Row className="center-login-form">
        <Col sm={6}>
                <div style={{ position: 'sticky', top: '100px' }}>
                <img src={colorScheme === 'light' ? lightloginURL : darkloginURL} alt="Do-Digital" />
                </div>
              </Col>
          <Col sm={6}>
              <div className="login-main">
                <div style={styles} className="log-bor">&nbsp;</div>
                <span style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }} className="steps">You can register your organization here.</span>
                <div className="log log-1">
                  <div className="login login-new">
                    <p>Welcome to this exciting world. Let’s work together to make this world even more thrilling.</p>
                    <Form onSubmit={handleLogin}>
                      <Row className="mb-3">
                        <Form.Group controlId="formGridUserId">
                        <Form.Label>ID (Email or Username)</Form.Label>
                          <Form.Control
                            type="text"
                             placeholder="Enter ID"
                            value={id}
                            onChange={(e) => setId(e.target.value)}
                            style={inputStyles(focusedInput === 'id')}
                            onFocus={() => setFocusedInput('id')}
                            onBlur={() => setFocusedInput(null)}
                            required
                          />
                        </Form.Group>
                      </Row>
                      <Row className="mb-3">
      <Form.Group controlId="formGridPassword">
        <Form.Label>Password</Form.Label>
        <div style={{ position: 'relative' }}>
          <Form.Control
            type={showPassword ? 'text' : 'password'} // Toggle between password and text
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyles(focusedInput === 'password')}
            onFocus={() => setFocusedInput('password')}
            onBlur={() => setFocusedInput(null)}
            required
          />
          {/* Eye icon for show/hide functionality */}
          <FontAwesomeIcon
            icon={showPassword ? faEye : faEyeSlash}
            onClick={togglePasswordVisibility}
            style={{
              position: 'absolute',
              top: '50%',
              right: '10px',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
            }}
          />
        </div>
      </Form.Group>
    </Row>
                      <Form.Group className="mb-3 d-flex align-center justify-content" id="formGridCheckbox">
      {/* Custom Checkbox */}
      <div className="d-flex align-center">
      <div style={checkboxStyles} onClick={handleCheck}>
        <span style={checkmarkStyles}>✔</span>
      </div>
      <label style={{ marginLeft: '10px', }}>Remember Me</label>
      </div>
      <Link to="/">Forgot Password?</Link>
    </Form.Group>
                      <Button variant="primary" type="submit" style={{ background: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                      Login
                      </Button>
                    </Form>
                    <div className="v-col v-col-12 d-flex align-center"><hr className="v-divider v-theme--light" aria-orientation="horizontal" role="separator"></hr><span className="mx-4">or</span><hr className="v-divider v-theme--light" aria-orientation="horizontal" role="separator"></hr></div>
                    <div className="v-col v-col-12 text-center text-base"><span>New on our platform?</span><Link to="/Organization-Registration" className="text-primary ms-2"> Create an account </Link></div>
                  </div>
                </div>
              </div>
          </Col>
        </Row>
      </Container>
      </section>

      <MessageModal
        show={showModal}
        handleClose={handleCloseModal}
        messageInfo={messageInfo}
      />
      <NewPopupModal
        show={showNewPopup}
        handleClose={() => setShowNewPopup(false)}
        popupInfo={newPopupInfo}
      />
      <Footer />
    </>
  );
};

export default Login;
